import styled, { css } from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp16};

  background-color: ${props =>
    props.index % 2 === 0 ? props.theme.colors.text.inverse : props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const ChipsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const Date = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`

export const MethodsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const MethodContainer = styled.div`
  background-color: ${props => props.theme.colors.warning.surface};
  color: ${props => props.theme.colors.warning.onSurface};
  border-radius: ${props => props.theme.primitives.radius.radius6};
  height: ${props => props.theme.size.S};
  width: ${props => props.theme.size.S};
  display: flex;
  justify-content: center;
  align-items: center;

  svg path {
    fill: currentColor;
  }

  ${props =>
    props.isDisabled &&
    css`
      background-color: ${props => props.theme.colors.disabled.surface};
      color: ${props => props.theme.colors.text.subtle};
    `}
`

export const DateAndMenuContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp8};
`

export const MethodsAndChipsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const MethodsAndInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
